export const filter = {
    id: null,
    name: '',
    code: '',
    symbol: '',
    rate: '',
    is_active: false,
    created_at: '',
    updated_at: '', 
};
